module.exports = __webpack_public_path__ + "img/syukyaku-EC-websit-001.b4bd43ac.jpg";